import { ReactElement } from "react";

export default function IconSuccess(): ReactElement {
  // metabot-success.svg
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
    >
      <g clipPath="url(#clip0_22199_2374)">
        <circle cx="48" cy="48" r="48" fill="#071722" fillOpacity="0.02" />
        <rect
          x="24"
          y="34.0004"
          width="48"
          height="34"
          rx="4"
          fill="#071722"
          fillOpacity="0.02"
          stroke="#92999E"
          strokeWidth="1.25"
          strokeLinejoin="round"
        />
        <rect
          x="29.5"
          y="39.5004"
          width="37"
          height="20"
          rx="1.5"
          fill="white"
          stroke="#92999E"
          strokeWidth="1.25"
          strokeLinejoin="round"
        />
        <path
          d="M61.0708 62.6254C61.6723 62.6254 62.1604 63.1129 62.1606 63.7143C62.1606 64.3159 61.6724 64.8041 61.0708 64.8041C60.4694 64.8039 59.9819 64.3158 59.9819 63.7143C59.9822 63.113 60.4695 62.6257 61.0708 62.6254Z"
          stroke="#92999E"
          strokeWidth="1.25"
        />
        <path
          d="M65.5708 62.6254C66.1723 62.6254 66.6604 63.1129 66.6606 63.7143C66.6606 64.3159 66.1724 64.8041 65.5708 64.8041C64.9694 64.8039 64.4819 64.3158 64.4819 63.7143C64.4822 63.113 64.9695 62.6257 65.5708 62.6254Z"
          stroke="#92999E"
          strokeWidth="1.25"
        />
        <circle cx="41" cy="46.5" r="1.5" fill="#92999E" />
        <circle opacity="0.5" cx="59.5" cy="25.5" r="1.5" fill="#92999E" />
        <circle cx="55" cy="46.5" r="1.5" fill="#92999E" />
        <path
          d="M50.25 50.5C50.25 51.9912 49.2426 52.75 48 52.75C46.7574 52.75 45.75 51.9912 45.75 50.5"
          stroke="#92999E"
          strokeWidth="1.25"
        />
        <path
          d="M69 25L70.6971 29.3029L75 31L70.6971 32.6971L69 37L67.3029 32.6971L63 31L67.3029 29.3029L69 25Z"
          fill="white"
          stroke="#92999E"
          strokeWidth="1.25"
          strokeLinejoin="round"
        />
        <circle
          cx="73"
          cy="46"
          r="2"
          fill="white"
          stroke="#92999E"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_22199_2374">
          <rect width="96" height="96" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
